import { OfferCard } from '@/components/Shared/ui';

import { OfferDetails } from '../../entities';
import { getOfferBodyProducts } from '../../helpers/offerBodyProduct';
import type { TBankOffers } from '../../types/bank-offer.types';
import useFormulateOfferItem from './hooks/useFormulateOfferItem';

interface IProps {
  bankOffer: TBankOffers;
}

const MfoDeclinedItem: React.FC<IProps> = ({ bankOffer: initialBankOffer }) => {
  const {
    additionalProducts,
    bankOffer,
    getDescription,
    headerIcon,
    headerTitle,
    isMobile,
    offerDetailsModal,
    setOfferDetailsModal
  } = useFormulateOfferItem({
    bankOffer: initialBankOffer
  });

  return (
    <>
      <OfferCard
        className="bank-item"
        extId={bankOffer.extId || undefined}
        status="error"
        statusText={bankOffer.status.name}
      >
        <OfferCard.Header
          title={headerTitle}
          icon={headerIcon}
          status="error"
          requestBodyInfo={{
            bankName: bankOffer.bank.name,
            responsePrimaryBody: bankOffer.responsePrimaryBody,
            responseSendedBody: bankOffer.responseSendedBody
          }}
          descriptionAction={
            bankOffer.bankDescription
              ? {
                  onClick: () => setOfferDetailsModal(true),
                  text: <span className="offer-body__hidden">Описание</span>
                }
              : undefined
          }
          defaultMobileView={false}
        />

        {bankOffer.hasApprovedDate && (
          <OfferCard.Body
            additionalProducts={additionalProducts}
            products={getOfferBodyProducts({
              monthlyPayment: bankOffer.monthlyPayment,
              rate: bankOffer.rate,
              loanPeriod: bankOffer.loanPeriod,
              loanAmount: bankOffer.loanAmount,
              initialPayment: bankOffer.initialPayment,
              bankProduct: bankOffer.product,
              isMobile
            })}
          />
        )}
      </OfferCard>

      <OfferDetails
        bankCode={bankOffer.bank.name}
        bankResponse={{
          allResponse: getDescription()
        }}
        historyData={{
          bank: bankOffer.bank.name.replace(/_/g, ''),
          offerId: bankOffer.id
        }}
        isOpened={!!offerDetailsModal}
        onClose={setOfferDetailsModal}
      />
    </>
  );
};

export default MfoDeclinedItem;
